module.exports = __webpack_public_path__ + "img/home-service-siyouhua.b409f2ec.png";